import { proxy } from "valtio";
import { ElementType } from "react";
import { ResponsiveValue } from "@chakra-ui/react";

import { MailType } from "../../../../types/mailcredit";
import CountdownSample from "../EmailTemplates/CountdownSample";
import { RsvpReminderSample, ThankYouNoteSample } from "../EmailTemplates";
import AccessCardPreview from "../EmailTemplates/AccessCardPreview";
import { OneToTwentyNine, Reminder, ReminderSchedule, ReminderScheduleType, WeekDays } from "../../../../types/reminder";
import { editorState } from "../../../../utils/editor";
import WeddingInviteWithWhatsApp from "../components/WeddingInviteWithWhatsApp";

export type InviteCardProps = {
  w?: ResponsiveValue<string | number>;
  h?: ResponsiveValue<string | number>;
  px?: ResponsiveValue<string | number>;
  helloText?: ResponsiveValue<string | number>;
  inviteText?: ResponsiveValue<string | number>;
  circleSize?: ResponsiveValue<string | number>;
  nameSize?: ResponsiveValue<string | number>;
  scheduleSize?: ResponsiveValue<string | number>;
  venueSize?: ResponsiveValue<string | number>;
  letUsKnowSize?: ResponsiveValue<string | number>;
  btnSize?: ResponsiveValue<string | number>;
  btnBg?: ResponsiveValue<string>;
  btnW?: ResponsiveValue<string | number>;
  border?: ResponsiveValue<number | (string & {})>;
};


export const MailTypeCardMap: Record<MailType, ElementType> = {
  [MailType.GuestInvite]: WeddingInviteWithWhatsApp,
  [MailType.AccessCard]: AccessCardPreview,
  [MailType.RsvpReminder]: RsvpReminderSample,
  [MailType.Countdown]: CountdownSample,
  [MailType.ThankYouNote]: ThankYouNoteSample,
};

export const createNewReminderSchedule = (): ReminderSchedule => (
  {
    _id: "",
    reminderScheduleType: "" as unknown as ReminderScheduleType,
    mailType: MailType.Countdown,
    reminderWeekDay: "" as unknown as WeekDays,
    reminderMonthDate: {
      day: null as unknown as OneToTwentyNine,
      isLastDay: false,
    },
    selectedDates: [],
    guests: [],
    sendToAll: false,
  }
);

export const WeddingReminderStore = proxy<Record<MailType, ReminderSchedule>>(
  {
    [MailType.AccessCard]: createNewReminderSchedule(),
    [MailType.Countdown]: createNewReminderSchedule(),
    [MailType.ThankYouNote]: createNewReminderSchedule(),
    [MailType.GuestInvite]: createNewReminderSchedule(),
    [MailType.RsvpReminder]: createNewReminderSchedule(),
  }
);

export const getSelectedDatesFromExecutionTimeTaskMap = (executionTimeMap: Record<string, Date>): Date[] => {
  // const dateStrs = Object.keys(executionTimeMap);
  // const selectedDates = dateStrs.map((d) => new Date(d))
  // console.log({dateStrs, selectedDates});
  return Object.keys(executionTimeMap).map((d) => new Date(d));
};
export const updateMailTypeInWeddingReminderStore = (mailType: MailType, reminder: Reminder) => {
  WeddingReminderStore[mailType]._id = reminder._id;
  editorState.mailRemindersMap[mailType] = reminder._id;
  WeddingReminderStore[mailType].reminderScheduleType = reminder.reminderScheduleType || "" as unknown as ReminderScheduleType;
  WeddingReminderStore[mailType].mailType = reminder.mailType;
  WeddingReminderStore[mailType].guests = reminder.guests;
  WeddingReminderStore[mailType].sendToAll = reminder.sendToAll;
  WeddingReminderStore[mailType].reminderWeekDay = reminder.reminderWeekDay || "" as unknown as WeekDays;
  WeddingReminderStore[mailType].reminderMonthDate = reminder.reminderMonthDate || {
    day: null as unknown as OneToTwentyNine,
    isLastDay: false,
  };
  WeddingReminderStore[mailType].selectedDates = reminder.reminderScheduleType === ReminderScheduleType.Custom ? getSelectedDatesFromExecutionTimeTaskMap(reminder.executionTimeMap) : [];
};

export const MessagingStore = proxy<{
  mailType: MailType;
  isWhatsAppMode: boolean;
  prefilledGuestIDs: string[];
}>(
  {
    mailType: MailType.GuestInvite,
    isWhatsAppMode: false,
    prefilledGuestIDs: [],
  }
);

export type GetSearchData = (props: {
  search: string,
  onCompleted: (shouldError: boolean) => void,
  onError: () => void,
},
) => void;
